/* HeyBear · Marquee band: native scroll-linked movement that survives refreshes. */
HB.section('marquee', function (root) {
  var track = root.querySelector('#bandTrack');
  var first = track && track.firstElementChild;
  var second = first && first.nextElementSibling;
  var frame = 0, loopWidth = 0, destroyed = false, off = [];
  if (!track || !first || !second || HB.reduce) return;

  function on(target, event, fn, options) {
    target.addEventListener(event, fn, options);
    off.push(function () { target.removeEventListener(event, fn, options); });
  }

  function measure() {
    if (destroyed) return;
    loopWidth = Math.max(0, second.offsetLeft - first.offsetLeft);
    requestDraw();
  }

  function draw() {
    frame = 0;
    if (destroyed || !loopWidth) return;
    var rect = root.getBoundingClientRect();
    var range = window.innerHeight + rect.height;
    var progress = Math.max(0, Math.min(1, (window.innerHeight - rect.top) / range));
    track.style.transform = 'translate3d(' + (-loopWidth * progress) + 'px,0,0)';
  }

  function requestDraw() {
    if (!frame) frame = requestAnimationFrame(draw);
  }

  on(window, 'scroll', requestDraw, { passive: true });
  on(window, 'resize', measure, { passive: true });
  on(window, 'load', measure);
  on(window, 'pageshow', measure);
  on(document, 'visibilitychange', function () { if (!document.hidden) measure(); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure).catch(function () {});
  measure();

  return function () {
    destroyed = true;
    off.forEach(function (remove) { remove(); });
    if (frame) cancelAnimationFrame(frame);
    track.style.transform = '';
  };
});
